export default "__VITE_ASSET__c3c8935d__"